import React, { useEffect, useState } from "react";
import useApi from "../../../../Hooks/useApi";
import LineChart from ".";
import { fetchLineChartData } from "./Utils";
import EmptyChart from "../EmptyChart";
import LoadingSpinner from "../../../Shared/LoadingSpinner";

const LineChartContainer = ({
  datasetTwo,
  containerClassName = "",
  exportRef,
  selectedCity,
  selectedYear
}) => {
  
  const [areaData, setAreaData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [error, setError] = useState(null); 

  const { request, loading } = useApi({ isPublic: true });

  useEffect(() => {
    setAreaData([]);
    setTotalValue(0);
    setError(null);

   
    if (!selectedCity?.id || !datasetTwo?.name) {
      return;
    }

    const fetchData = async () => {
      try {
        const result = await fetchLineChartData(request, {
          location: selectedCity?.id,
          query: datasetTwo?.name,
          year: selectedYear
        });

     
        if (!result) {
          throw new Error("Received empty response from server.");
        }


        if (!Array.isArray(result.data)) {
          console.warn("LineChart: result.data is not an array", result);
          setAreaData([]);
          return;
        }

        setTotalValue(result.total || 0);

        const updatedData = result.data
          .filter((d) => {
            if (!d) return false;
            
            const name = String(d.name || "").trim().toLowerCase();
            return name !== "null" && name!== null &&  name !== "undefined" && name !== "";
          })
          .map((d) => {
          
            let year = "N/A";
            
        
            const dateObj = new Date(d.name);
            if (!isNaN(dateObj)) {
              year = dateObj.getFullYear();
            } else {
              // Fallback: If d.name is just a number string "2023"
              const simpleYear = parseInt(d.name, 10);
              if (!isNaN(simpleYear)) {
                year = simpleYear;
              } else {
                // Final Fallback: Use the string itself
                year = d.name;
              }
            }

            return {
              year: year,
              value: Number(d.value) || 0, // Ensure value is a Number
            };
          })
          .sort((a, b) => {
            // Safe Sort: Handle cases where 'year' might be a string
            return (parseInt(a.year) || 0) - (parseInt(b.year) || 0);
          });

        setAreaData(updatedData);

      } catch (err) {
        console.error("LineChart Error:", err);
        setError("Unable to load chart data.");
      }
    };

    fetchData();
  }, [selectedCity, datasetTwo, request]); 



  if (loading) {
    return <LoadingSpinner message="Loading Line Chart..." />;
  }


  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-[300px] border border-red-200 bg-red-50 rounded">
        <p className="text-red-500 font-semibold">{error}</p>
      </div>
    );
  }


  if (!areaData || areaData.length === 0 || totalValue === 0) {
    return <EmptyChart />;
  }


  return (
    <LineChart
      data={areaData}
      totalValue={totalValue}
      datasetTwo={datasetTwo}
      containerClassName={containerClassName}
      exportRef={exportRef}
      selectedCity={selectedCity}
      year={selectedYear}
    />
  );
};

export default LineChartContainer;